
import * as React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';

function SectionTitle({ children }) {
  return (
    <Typography component="h3" variant="h3" gutterBottom>
      {children}
    </Typography>
  );
}

SectionTitle.propTypes = {
  children: PropTypes.node.isRequired,
};

export default SectionTitle;